/**
 * Dependencies.
 */
import { BaseModel, endpoint, prop } from '@prz-dp/services';

/**
 * Export model `SupervisorModel`.
 */
@endpoint('partnerships/supervisors')
export class SupervisorModel extends BaseModel {
  /**
   * Properties.
   */
  @prop()
  id: number;

  @prop()
  name: string;

  /**
   * Constructor.
   */
  constructor(data?: Partial<SupervisorModel>) {
    super(data);
  }
}
